module.exports = __webpack_public_path__ + "img/yamaxun1.5a2905e6.png";